import {svgIconWrapper} from '../svg-icon-wrapper';

import WarningRegular from './warning-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <WarningRegular {...props} />;
}
SvgComponent.iconName = 'warningRegular';

export const WarningRegularIcon = svgIconWrapper(SvgComponent);
